// import React from 'react'
// import { Link } from 'react-router-dom'
// import { ILink } from '../../organisms/ListLink'

// const MobileMenu:React.FC<ILink> = ({Logo, Title, link}) => {
//   return (
//     <li className='list-none'>
//         <Link className='flex flex-col items-center cursor-pointer w-8 h-8' to={`/${link}`}>
//             <div className=''>
//               {Logo}
//             </div>
//             <span className='text-xs'>{Title}</span>
//         </Link>
//     </li>
//   )
// }

// export default MobileMenu

// ------ version 2 -------
import React from "react";
import { Link } from "react-router-dom";

export interface ILink {
  Logo: React.ReactNode;
  Title: string;
  link: string;
  isDark?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}

const MobileMenu: React.FC<ILink> = ({
  Logo,
  Title,
  link,
  isDark,
  isActive,
  onClick,
}) => {
  return (
    <li className="list-none">
      <Link
        to={`/${link}`}
        onClick={onClick}
        className={`flex flex-col items-center justify-center w-16 h-14 rounded-md transition-colors duration-200 ${
          isActive
            ? isDark
              ? "text-indigo-400 bg-gray-700"
              : "text-indigo-600 bg-gray-100"
            : isDark
            ? "text-gray-300 hover:text-white hover:bg-gray-700"
            : "text-gray-700 hover:text-gray-900 hover:bg-gray-100"
        }`}
        aria-label={Title}
      >
        <div className="flex items-center justify-center h-6">{Logo}</div>
        <span className="text-xs mt-1">{Title}</span>
      </Link>
    </li>
  );
};

export default MobileMenu;
